export const COLOR = {
  font: {
    icon: '#BCC4C8',
    base: '#2C3E50',
  },
  border: {
    base: '#BCC4C8',
  },
  background: {
    base: '#e5e5e5',
  },
} as const;
